import React, { useState } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { getOptamonCookieConsent } from './CookieShield.helpers';
import IconCookieShield from '../../assets/CookieShield/IconCookieShield';
import { Tile } from '../../components/atoms/Tile';
import TeaserTileContent from '../../components/molecules/TeaserTile/partials/TeaserTileContent';

const StyledTile = styled(Tile)`
  @media (max-width: 579px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    & > svg {
      width: 35% !important;
      height: 35% !important;
    }
  }

  @media (min-width: 580px) {
    display: grid;
    grid-template-columns: 70% 30%;
    align-items: center;
    justify-items: center;
  }
`;

/**
 * @param {Function} setConsentHasChanged
 * @returns {void}
 */
const openOneTrustPreferencesCenter = (setConsentHasChanged) => {
  if (typeof window !== 'undefined' && window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
    window.OneTrust.OnConsentChanged(() => setConsentHasChanged((cHC) => !cHC));
  }
};

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} props.category
 * @returns {React.ReactElement} The rendered component
 */
const CookieShield = ({ children, category }) => {
  const [, setConsentHasChanged] = useState(false);
  const categoryHasUserConsent = getOptamonCookieConsent(category);
  const intl = useIntl();
  // From OneTrust cookie (OptamonConsent) 1 means consent, 0 means rejected
  return (
    <>
      {categoryHasUserConsent === '1' && <>{children}</>}
      {categoryHasUserConsent === '0' && (
        <div
          onClick={() => openOneTrustPreferencesCenter(setConsentHasChanged)}
        >
          <StyledTile isClickable>
            <TeaserTileContent
              type={'MEDIUM'}
              headline={intl.formatMessage({
                id: 'cookieShield.headline',
              })}
              text={intl.formatMessage({
                id: 'cookieShield.description',
              })}
              readmoreText={intl.formatMessage({ id: 'cookieShield.ctaText' })}
              isClickable
              parentContainerType={1}
            />
            <IconCookieShield size="85%" />
          </StyledTile>
        </div>
      )}
    </>
  );
};

export default CookieShield;
